import { render, staticRenderFns } from "./input-textarea-mac.vue?vue&type=template&id=48af9ae0&scoped=true"
import script from "./input-textarea-mac.vue?vue&type=script&lang=js"
export * from "./input-textarea-mac.vue?vue&type=script&lang=js"
import style0 from "./input-textarea-mac.vue?vue&type=style&index=0&id=48af9ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af9ae0",
  null
  
)

export default component.exports